// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"368":"bf96bb6da1dbe13264f5","7405":"1f945e9102c3f2a5bc4f"}[chunkId] + ".chunk.css";
};